"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var menu_1 = require("./menu");
var Artwork_1 = require("./Dashboard/Artwork");
var Product_1 = __importDefault(require("./Dashboard/Product"));
var Container_1 = require("./Dashboard/Product/Container");
var Container_2 = require("./Dashboard/Artwork/Container");
var Home_1 = __importDefault(require("./Dashboard/Home"));
var Order_1 = __importDefault(require("./Dashboard/Order"));
// const {useLayoutEffect, useRef, useState} = React
var App = function () {
    var _a, _b, _c, _d;
    var customer = window.__initialState.customer;
    React.useEffect(function () {
        window._learnq = window._learnq || [];
        window._learnq.push([
            "identify",
            {
                $email: customer.email,
                $first_name: customer.firstName,
                $last_name: customer.lastName
            }
        ]);
        window._learnq.push([
            "identify",
            {
                IsApproved: true
            }
        ]);
        if (window.LOU) {
            window.LOU.identify(customer._id, __assign(__assign({ isAuthenticated: true }, customer), { _id: undefined, business: undefined, tid: undefined }));
        }
    }, []);
    // const appRef = useRef(null)
    // const appSideBarRef = useRef(null)
    // const [contentSize, setContentSize] = useState(0)
    // useLayoutEffect(() => {
    //   console.log('appSideBarRef', appSideBarRef)
    //   console.log('appRef', appRef)
    //   const size = () => {
    //     const appWidth = appRef.current?.getBoundingClientRect()?.width;
    //   const sideWidth = appSideBarRef.current?.getBoundingClientRect()?.width;
    //   console.log('appWidth', appWidth, 'sideWidth',  sideWidth);
    //     setContentSize(appWidth - sideWidth)
    //   }
    //   window.addEventListener("resize", size)
    //   return () => {
    //     window.removeEventListener("resize", size)
    //   }
    // }, [])
    // console.log('contentSize', contentSize);
    var Product = function () { return (React.createElement(Container_1.Container, null,
        React.createElement(Product_1.default, null))); };
    var Artwork = function () { return (React.createElement(Container_2.ArtworkContainer, null,
        React.createElement(Artwork_1.Artwork, null))); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex" },
            React.createElement("div", { className: "sidebar-container " },
                React.createElement("aside", { className: "sidebar mt-md-5 dash-sidebar" },
                    React.createElement("h2", { className: "sidebar-user-name font-weight-med" },
                        React.createElement("span", { className: "welcome-name" },
                            "Welcome, ",
                            React.createElement("br", null),
                            " ", (_a = customer === null || customer === void 0 ? void 0 : customer.firstName) !== null && _a !== void 0 ? _a : "",
                            "!")),
                    React.createElement("span", { className: "welcome-name-init" }, (_d = (_c = (_b = customer === null || customer === void 0 ? void 0 : customer.firstName) === null || _b === void 0 ? void 0 : _b.split("")) === null || _c === void 0 ? void 0 : _c.splice(0, 1)) === null || _d === void 0 ? void 0 : _d.join("")),
                    React.createElement(menu_1.Menu, null))),
            React.createElement("div", { className: "app-content", style: { width: "0" } },
                React.createElement("div", { className: "content p-3 pt-md-0 pl-md-4 pr-md-0 h-100" },
                    React.createElement(react_router_dom_1.Switch, null,
                        React.createElement(react_router_dom_1.Route, { exact: true, path: "/dashboard", component: Home_1.default }),
                        React.createElement(react_router_dom_1.Route, { path: "/dashboard/my-artwork-library", component: Artwork }),
                        React.createElement(react_router_dom_1.Route, { path: "/dashboard/my-product-library", component: Product }),
                        React.createElement(react_router_dom_1.Route, { path: "/dashboard/order-history", component: Order_1.default })))))));
};
exports.default = App;
